import { call, put, takeEvery } from 'redux-saga/effects';
import { changeBikeModel } from '../../requests/change_bike_model_request';
import { changeBikeModelRequestSuccess, changeBikeModelRequestFailure } from '../actions/change_bike_model.actions';
import { CHANGE_BIKE_MODEL_REQUEST } from '../../../BikeManagement/redux/constants/bike_model.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* changeBikeModelRequest({ model_id, key, value }) {
    const changed_model = yield call(changeBikeModel, model_id, key, value);
    const { result, status } = changed_model;
    if (status) {
        yield put(changeBikeModelRequestSuccess(key, result));
        message_success('Bike model updated successfully!');
    } else {
        yield put(changeBikeModelRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changeBikeModelSaga() {
    yield takeEvery(CHANGE_BIKE_MODEL_REQUEST, changeBikeModelRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/sagas/change_bike_model.saga.js